import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const moversOverviewComponent = Loadable(() => import('../containers/index'));
export default MapTo('vcg/components/soe-home/react/movers/overview')(moversOverviewComponent);
